// Faithful JS port of the reference circularity-data.ts (TypeScript types stripped, runtime values unchanged).

export const materials = [
  {
    id: "m1",
    type: "Metals",
    category: "Aluminium",
    subCategory: "Aluminium profiles",
    description: "Aluminium Profile (Anodized)",
    mass: 2700,
    gwp: 39_712_680,
    cost: 12500,
    productLifeYears: 60,
    industryAvgYears: 60,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 40,
    recycledPct: 55,
    reusedPct: 0,
    remanufacturedPct: 5,
    renewablePct: 0,
    recyclingEfficiency: 92,
    eolRecycled: 80,
    eolReused: 5,
    eolLandfill: 10,
    eolIncinerated: 5,
    mci: 0.62,
    lfi: 0.38,
    aiMatchConfidence: 96,
    dataSource: "Ecoinvent 3.10",
    dataQuality: "High",
  },
  {
    id: "m2",
    type: "Insulation Materials",
    category: "Straw",
    subCategory: "Straw bale",
    description: "Straw Insulation",
    mass: 600,
    gwp: 289.16,
    cost: 800,
    productLifeYears: 40,
    industryAvgYears: 40,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 100,
    recycledPct: 0,
    reusedPct: 0,
    remanufacturedPct: 0,
    renewablePct: 100,
    recyclingEfficiency: 30,
    eolRecycled: 10,
    eolReused: 0,
    eolLandfill: 30,
    eolIncinerated: 60,
    mci: 0.71,
    lfi: 0.29,
    aiMatchConfidence: 88,
    dataSource: "ARIVU DB",
    dataQuality: "Medium",
  },
  {
    id: "m3",
    type: "Metals",
    category: "Aluminium",
    subCategory: "Aluminium profiles",
    description: "Aluminium Profile (Raw)",
    mass: 1200,
    gwp: 43_672.0,
    cost: 4200,
    productLifeYears: 60,
    industryAvgYears: 60,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 70,
    recycledPct: 30,
    reusedPct: 0,
    remanufacturedPct: 0,
    renewablePct: 0,
    recyclingEfficiency: 90,
    eolRecycled: 75,
    eolReused: 5,
    eolLandfill: 15,
    eolIncinerated: 5,
    mci: 0.48,
    lfi: 0.52,
    aiMatchConfidence: 94,
    dataSource: "Ecoinvent 3.10",
    dataQuality: "High",
  },
  {
    id: "m4",
    type: "Metals",
    category: "Steel and iron",
    subCategory: "Structural steel profile",
    description: "Annealed Wire Rod",
    mass: 850,
    gwp: 3_016.87,
    cost: 1600,
    productLifeYears: 60,
    industryAvgYears: 60,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 50,
    recycledPct: 45,
    reusedPct: 5,
    remanufacturedPct: 0,
    renewablePct: 0,
    recyclingEfficiency: 88,
    eolRecycled: 82,
    eolReused: 4,
    eolLandfill: 10,
    eolIncinerated: 4,
    mci: 0.59,
    lfi: 0.41,
    aiMatchConfidence: 97,
    dataSource: "Ecoinvent 3.10",
    dataQuality: "High",
  },
  {
    id: "m5",
    type: "Metals",
    category: "Aluminium",
    subCategory: "Aluminium profiles",
    description: "Electrostatically Powder-Coated",
    mass: 480,
    gwp: 18_086.8,
    cost: 2100,
    productLifeYears: 60,
    industryAvgYears: 60,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 60,
    recycledPct: 40,
    reusedPct: 0,
    remanufacturedPct: 0,
    renewablePct: 0,
    recyclingEfficiency: 85,
    eolRecycled: 70,
    eolReused: 0,
    eolLandfill: 20,
    eolIncinerated: 10,
    mci: 0.51,
    lfi: 0.49,
    aiMatchConfidence: 91,
    dataSource: "ARIVU DB",
    dataQuality: "Medium",
  },
  {
    id: "m6",
    type: "Metals",
    category: "Steel and iron",
    subCategory: "Structural steel profile",
    description: "Steel Wire Baskets",
    mass: 320,
    gwp: 1.63,
    cost: 900,
    productLifeYears: 60,
    industryAvgYears: 60,
    functionalUnits: 1,
    industryAvgUnits: 1,
    virginPct: 20,
    recycledPct: 78,
    reusedPct: 2,
    remanufacturedPct: 0,
    renewablePct: 0,
    recyclingEfficiency: 90,
    eolRecycled: 85,
    eolReused: 5,
    eolLandfill: 8,
    eolIncinerated: 2,
    mci: 0.78,
    lfi: 0.22,
    aiMatchConfidence: 95,
    dataSource: "Ecoinvent 3.10",
    dataQuality: "High",
  },
];

export const projectSummary = {
  name: "Project Circularity",
  code: "10-7-26 db test",
  totalMass: 8708,
  projectMci: 42.34,
  totalGwp: 79572.63,
  totalCost: 21100,
};

export const designAssessment = {
  repairable: 3,
  upgradeable: 2,
  modular: 4,
  disassembly: 3,
  replaceableParts: 4,
  standardFasteners: 5,
};

export const recommendations = [
  {
    title: "Increase recycled aluminium content",
    impact: "+6.2 MCI pts",
    effort: "Medium",
    detail: "Switch anodized aluminium profiles from 40% to 65% recycled feedstock. Estimated GWP reduction: 18%.",
    priority: "High",
  },
  {
    title: "Improve product disassembly",
    impact: "+3.1 MCI pts",
    effort: "Low",
    detail: "Replace bonded joints with standard M6 mechanical fasteners on the aluminium frame subsystem.",
    priority: "High",
  },
  {
    title: "Increase renewable content in insulation",
    impact: "+2.4 MCI pts",
    effort: "Low",
    detail: "Already 100% straw; extend renewable strategy to secondary insulation layer.",
    priority: "Medium",
  },
  {
    title: "Recovery loop for steel wire baskets",
    impact: "+1.8 MCI pts",
    effort: "Medium",
    detail: "Establish take-back agreement with fabricator to reach 90% recovery.",
    priority: "Medium",
  },
  {
    title: "Reduce virgin material in powder-coated components",
    impact: "+1.2 MCI pts",
    effort: "High",
    detail: "Requalify secondary aluminium supplier for powder-coated line.",
    priority: "Low",
  },
];

export const benchmarks = [
  { label: "Current Product", mci: 42.3, gwp: 79.5, cost: 21.1 },
  { label: "Previous Version", mci: 36.1, gwp: 88.2, cost: 19.4 },
  { label: "Company Average", mci: 39.8, gwp: 82.1, cost: 20.2 },
  { label: "Industry Average", mci: 34.2, gwp: 94.7, cost: 22.8 },
  { label: "Best-in-Class", mci: 61.7, gwp: 52.4, cost: 24.9 },
];

// --- Utility → Input Material rows (per screenshot 1) ---
export const inputMaterialSeed = [
  { id: "i1", description: "Synthetic resin", recycledPct: 0, reusePct: 0, remanufacturedPct: 0, virginPct: 100, virginMass: 2.83 },
  { id: "i2", description: "Glass", recycledPct: 0, reusePct: 0, remanufacturedPct: 0, virginPct: 100, virginMass: 1.16 },
  { id: "i3", description: "CLF Gypsum Board", recycledPct: 0, reusePct: 0, remanufacturedPct: 0, virginPct: 100, virginMass: 75.08 },
  { id: "i4", description: "Fibrous Inorganic Glasswool", recycledPct: 0, reusePct: 0, remanufacturedPct: 0, virginPct: 100, virginMass: 20.93 },
];

// --- Utility → Output Material rows (per screenshot 2) ---
export const outputMaterialSeed = [
  { id: "o1", description: "Synthetic resin", sentToRecyclingPct: 20, reusedPct: 0, bioCompostedPct: 0, bioEnergyPct: 0, wasteContentPct: 80, wasteToLandfillPct: 2.26 },
  { id: "o2", description: "Glass", sentToRecyclingPct: 70, reusedPct: 0, bioCompostedPct: 0, bioEnergyPct: 0, wasteContentPct: 30, wasteToLandfillPct: 0.35 },
  { id: "o3", description: "CLF Gypsum Board", sentToRecyclingPct: 30, reusedPct: 0, bioCompostedPct: 0, bioEnergyPct: 0, wasteContentPct: 70, wasteToLandfillPct: 52.56 },
  { id: "o4", description: "Fibrous Inorganic Glasswool", sentToRecyclingPct: 20, reusedPct: 0, bioCompostedPct: 0, bioEnergyPct: 0, wasteContentPct: 80, wasteToLandfillPct: 16.74 },
];

// --- Utility → End of Life rows (per screenshot 3) ---
export const endOfLifeSeed = [
  { id: "e1", description: "Synthetic resin", recyclingEfficiencyAfterUsePct: 70, recyclingEfficiencyOfRecycledMaterialPct: 90, wasteFromRecyclingProductPct: 0.17, wasteFromRecycledMaterialInProductPct: 0, totalUnrecoverableWastePct: 2.35 },
  { id: "e2", description: "Glass", recyclingEfficiencyAfterUsePct: 90, recyclingEfficiencyOfRecycledMaterialPct: 90, wasteFromRecyclingProductPct: 0.08, wasteFromRecycledMaterialInProductPct: 0, totalUnrecoverableWastePct: 0.39 },
  { id: "e3", description: "CLF Gypsum Board", recyclingEfficiencyAfterUsePct: 80, recyclingEfficiencyOfRecycledMaterialPct: 90, wasteFromRecyclingProductPct: 4.50, wasteFromRecycledMaterialInProductPct: 0, totalUnrecoverableWastePct: 54.81 },
  { id: "e4", description: "Fibrous Inorganic Glasswool", recyclingEfficiencyAfterUsePct: 80, recyclingEfficiencyOfRecycledMaterialPct: 90, wasteFromRecyclingProductPct: 0.84, wasteFromRecycledMaterialInProductPct: 0, totalUnrecoverableWastePct: 17.16 },
];

// --- Energy (ISO 59020 A.8) ---
export const energySeed = [
  { id: "en1", year: 2024, renewableInflow: 42_000, renewableOutflow: 1_500, totalInflow: 120_000, totalOutflow: 18_000 },
  { id: "en2", year: 2025, renewableInflow: 58_000, renewableOutflow: 2_100, totalInflow: 132_000, totalOutflow: 19_500 },
];

// --- Water (ISO 59020 A.9 / A.10 / A.11) ---
export const waterSeed = [
  { id: "wa1", year: 2024, circularInflow: 320, totalInflow: 1_200, circularDischarge: 250, waterReused: 180, externalWithdrawal: 900 },
  { id: "wa2", year: 2025, circularInflow: 410, totalInflow: 1_150, circularDischarge: 305, waterReused: 220, externalWithdrawal: 820 },
];

// --- Economic (ISO 59020 A.12 / A.13) ---
export const economicSeed = [
  { id: "ec1", year: 2024, revenue: 4_200_000, virginMaterialConsumed: 100, previousMaterialConsumption: 105, currentMaterialConsumption: 100, previousRevenue: 3_800_000, currentRevenue: 4_200_000 },
  { id: "ec2", year: 2025, revenue: 4_800_000, virginMaterialConsumed: 96, previousMaterialConsumption: 100, currentMaterialConsumption: 96, previousRevenue: 4_200_000, currentRevenue: 4_800_000 },
];

// --- Design Assessment Framework 2.0 (10 criteria × 5 sub-criteria) ---
export const designFramework = [
  { key: "durability", label: "Durability", definition: "Withstand use, wear and environmental stress over service life.", subCriteria: [
    { key: "serviceLife", label: "Design service life", score: 4 },
    { key: "wear", label: "Wear & abrasion resistance", score: 3 },
    { key: "corrosion", label: "Corrosion / environmental resistance", score: 4 },
    { key: "structural", label: "Structural robustness under load", score: 4 },
    { key: "maintenance", label: "Maintenance interval before major failure", score: 3 },
  ]},
  { key: "repairability", label: "Repairability", definition: "Ease of restoring the product after failure or damage.", subCriteria: [
    { key: "access", label: "Accessibility of repairable components", score: 3 },
    { key: "tools", label: "Repair using standard tools", score: 4 },
    { key: "docs", label: "Availability of repair documentation", score: 3 },
    { key: "spares", label: "Availability of spare parts", score: 4 },
    { key: "time", label: "Average repair time", score: 3 },
  ]},
  { key: "disassembly", label: "Disassembly", definition: "Ease of taking the product apart into parts and materials.", subCriteria: [
    { key: "time", label: "Time required for complete disassembly", score: 3 },
    { key: "nondestructive", label: "Non-destructive disassembly capability", score: 3 },
    { key: "steps", label: "Number of disassembly steps", score: 3 },
    { key: "separation", label: "Ease of separating material types", score: 2 },
    { key: "critical", label: "Ease of removing critical components", score: 3 },
  ]},
  { key: "modularity", label: "Modularity", definition: "Product composed of interchangeable functional modules.", subCriteria: [
    { key: "modules", label: "Independent functional modules", score: 4 },
    { key: "replace", label: "Ease of module replacement", score: 3 },
    { key: "interfaces", label: "Standardized module interfaces", score: 4 },
    { key: "dependency", label: "Minimal dependency between modules", score: 3 },
    { key: "addremove", label: "Ability to add/remove modules", score: 3 },
  ]},
  { key: "upgradeability", label: "Upgradeability", definition: "Enhance performance/function without full replacement.", subCriteria: [
    { key: "hw", label: "Hardware upgrade capability", score: 2 },
    { key: "sw", label: "Software / firmware update support", score: 3 },
    { key: "expand", label: "Expandability for future functions", score: 2 },
    { key: "future", label: "Compatibility with future components", score: 2 },
    { key: "nofullswap", label: "Upgrade without replacing entire product", score: 3 },
  ]},
  { key: "replaceability", label: "Replaceability", definition: "Ease of substituting worn or damaged parts.", subCriteria: [
    { key: "wear", label: "Replaceability of wear parts", score: 4 },
    { key: "compatible", label: "Availability of compatible parts", score: 4 },
    { key: "damaged", label: "Ease of replacing damaged components", score: 3 },
    { key: "standard", label: "Standardization of parts", score: 4 },
    { key: "noadjacent", label: "Replacement without damaging adjacent components", score: 3 },
  ]},
  { key: "reusability", label: "Reusability", definition: "Suitability of components for reuse after first life.", subCriteria: [
    { key: "potential", label: "Reuse potential of major components", score: 3 },
    { key: "asis", label: "Reuse without refurbishment", score: 2 },
    { key: "removal", label: "Ease of removing reusable parts", score: 3 },
    { key: "preserve", label: "Functionality preservation after first life", score: 3 },
    { key: "cross", label: "Compatibility for reuse in other products/systems", score: 2 },
  ]},
  { key: "refurbishability", label: "Refurbishability", definition: "Ease of restoring the product to like-new condition.", subCriteria: [
    { key: "clean", label: "Ease of cleaning and restoration", score: 3 },
    { key: "inspect", label: "Ease of inspection and testing", score: 3 },
    { key: "worn", label: "Ease of replacing worn parts during refurbishment", score: 3 },
    { key: "restore", label: "Ability to restore original performance", score: 3 },
    { key: "procs", label: "Availability of refurbishment procedures", score: 2 },
  ]},
  { key: "remanufacturability", label: "Remanufacturability", definition: "Suitability for industrial-scale remanufacturing.", subCriteria: [
    { key: "cores", label: "Recovery of core components", score: 3 },
    { key: "std", label: "Standardized interfaces for rebuilding", score: 3 },
    { key: "reassembly", label: "Ease of reassembly after remanufacturing", score: 3 },
    { key: "highvalue", label: "Reusability of high-value assemblies", score: 3 },
    { key: "verify", label: "Ease of quality verification after remanufacturing", score: 2 },
  ]},
  { key: "recyclability", label: "Recyclability", definition: "Ease of recovering materials at end of life.", subCriteria: [
    { key: "separation", label: "Material separation efficiency", score: 4 },
    { key: "pct", label: "Percentage of recyclable material by mass", score: 4 },
    { key: "identify", label: "Ease of identifying material types", score: 3 },
    { key: "composites", label: "Minimization of inseparable composite materials", score: 3 },
    { key: "hazardous", label: "Avoidance of hazardous substances that hinder recycling", score: 4 },
  ]},
];

export function dciGrade(dci) {
  if (dci >= 85) return "A";
  if (dci >= 70) return "B";
  if (dci >= 50) return "C";
  if (dci >= 30) return "D";
  return "E";
}

export const dciGradeInfo = {
  A: { band: "85–100", label: "Circular design leader" },
  B: { band: "70–84", label: "Strong performance, minor gaps" },
  C: { band: "50–69", label: "Moderate, clear gaps" },
  D: { band: "30–49", label: "Limited, redesign needed" },
  E: { band: "0–29", label: "Minimal/no circular design consideration" },
};

/** Common 0–5 scoring scale (generic guidance shown in tooltips). */
export const commonScoreScale = [
  { score: 0, label: "Not considered / N/A" },
  { score: 1, label: "Very poor" },
  { score: 2, label: "Basic" },
  { score: 3, label: "Moderate" },
  { score: 4, label: "Good" },
  { score: 5, label: "Best practice" },
];

/** Sub-criterion specific 0–5 threshold guidance for all 50 indicators (from ARIVU Design Framework v2.0). */
export const subGuidance = {
  // 1. Durability
  "durability.serviceLife": ["No defined service life", "Under 1 year", "1–3 years", "3–5 years", "5–10 years", "Over 10 years / industry-leading"],
  "durability.wear": ["Not considered", "Fails quickly under normal use", "Basic resistance, frequent wear issues", "Meets standard use conditions", "Good resistance, minimal wear over life", "Best-in-class materials/treatments, negligible wear"],
  "durability.corrosion": ["Not considered", "Fails quickly in intended environment", "Basic protection, early degradation", "Meets standard environmental exposure", "Good protection across expected conditions", "Best-in-class, validated for extreme/extended exposure"],
  "durability.structural": ["Not evaluated", "Fails under intended load", "Marginal safety factor", "Meets standard safety factor", "Exceeds required safety factor", "Validated by testing with significant margin"],
  "durability.maintenance": ["No maintenance plan defined", "Under 3 months", "3–6 months", "6–12 months", "1–3 years", "Over 3 years"],
  // 2. Repairability
  "repairability.access": ["Inaccessible / must destroy product", "Requires full disassembly", "Requires major disassembly", "Requires partial disassembly", "Accessible with few steps", "Immediately accessible (panel/latch)"],
  "repairability.tools": ["Requires proprietary/unavailable tools", "Requires rare specialized tools", "Requires some specialized tools", "Mix of standard and specialized tools", "Mostly standard tools", "Fully repairable with common tools"],
  "repairability.docs": ["None available", "Informal/undocumented", "Limited internal documentation only", "Basic manuals available", "Detailed manuals, publicly available", "Comprehensive public manuals plus guides/video"],
  "repairability.spares": ["Unavailable", "Rare / discontinued quickly", "Available under 2 years", "Available 2–5 years", "Available 5–10 years", "Long-term guaranteed availability, 10+ years"],
  "repairability.time": ["Not repairable", "Over 4 hours", "2–4 hours", "1–2 hours", "30–60 minutes", "Under 30 minutes"],
  // 3. Disassembly
  "disassembly.time": ["Not possible", "Over 60 minutes", "30–60 minutes", "15–30 minutes", "5–15 minutes", "Under 5 minutes"],
  "disassembly.nondestructive": ["Always destructive", "Mostly destructive", "Some destructive steps", "Mostly non-destructive, minor exceptions", "Non-destructive with basic tools", "Fully non-destructive / reversible"],
  "disassembly.steps": ["Cannot be disassembled", "More than 20 steps", "13–20 steps", "8–12 steps", "4–7 steps", "3 steps or fewer"],
  "disassembly.separation": ["Materials inseparable", "Very difficult separation", "Difficult, needs special process", "Moderate effort to separate", "Easy with basic tools", "Tool-free / snap separation"],
  "disassembly.critical": ["Cannot be removed", "Very difficult to remove", "Difficult, needs disassembly of others", "Moderate effort", "Easy to remove", "Immediate / tool-free removal"],
  // 4. Modularity
  "modularity.modules": ["Fully monolithic design", "Minimal modularity", "Few modules, high interdependency", "Moderate modularity", "Mostly modular, clear boundaries", "Fully modular, independent functional units"],
  "modularity.replace": ["Not replaceable", "Very difficult", "Difficult", "Moderate effort", "Easy", "Tool-free / plug-and-play"],
  "modularity.interfaces": ["No standardization", "Proprietary, unique per unit", "Partially standardized", "Standardized within product line", "Standardized across product family", "Industry-standard interfaces"],
  "modularity.dependency": ["Highly interdependent", "Significant dependency", "Moderate dependency", "Limited dependency", "Minimal dependency", "No dependency, fully autonomous"],
  "modularity.addremove": ["Impossible without redesign", "Requires major redesign", "Requires moderate redesign", "Requires minor adjustment", "Possible with minimal changes", "Fully plug-and-play expansion"],
  // 5. Upgradeability
  "upgradeability.hw": ["None", "Requires full replacement", "Limited upgrade options", "Moderate upgrade paths available", "Multiple upgrade paths", "Designed for continuous hardware upgrades"],
  "upgradeability.sw": ["None", "One-time only", "Updates under 1 year", "Updates for 1–3 years", "Updates for 3–5 years", "Long-term / OTA updates, 5+ years"],
  "upgradeability.expand": ["None", "Minimal headroom", "Limited expansion capacity", "Moderate expansion capacity", "Significant expansion capacity", "Explicitly designed for future feature growth"],
  "upgradeability.future": ["None", "Unlikely to be compatible", "Limited compatibility", "Moderate compatibility with next-gen parts", "High compatibility", "Full backward/forward compatibility by design"],
  "upgradeability.nofullswap": ["Always requires full replacement", "Rarely allows partial upgrade", "Sometimes allows partial upgrade", "Partial upgrade commonly possible", "Partial upgrade usually sufficient", "Always upgradeable without full replacement"],
  // 6. Replaceability
  "replaceability.wear": ["Not replaceable", "Very difficult", "Difficult", "Moderate effort", "Easy", "Tool-free replacement"],
  "replaceability.compatible": ["Unavailable", "Rare / discontinued quickly", "Available under 2 years", "Available 2–5 years", "Available 5–10 years", "Long-term guaranteed availability"],
  "replaceability.damaged": ["Impossible", "Very difficult", "Difficult", "Moderate effort", "Easy", "Very easy / quick"],
  "replaceability.standard": ["Fully proprietary", "Mostly proprietary", "Partially standardized", "Standardized within product line", "Standardized across product family", "Industry-standard parts"],
  "replaceability.noadjacent": ["Always damages adjacent parts", "Frequently damages", "Sometimes damages", "Occasionally damages", "Rarely damages", "Never damages adjacent components"],
  // 7. Reusability
  "reusability.potential": ["None", "Minimal potential", "Limited potential", "Moderate potential", "High potential", "Very high, explicitly designed for reuse"],
  "reusability.asis": ["Always needs refurbishment first", "Usually needs refurbishment", "Often needs refurbishment", "Sometimes needs refurbishment", "Rarely needs refurbishment", "Reusable as-is"],
  "reusability.removal": ["Cannot be removed", "Very difficult to remove", "Difficult", "Moderate effort", "Easy", "Immediate / tool-free removal"],
  "reusability.preserve": ["Degrades significantly", "Major degradation", "Moderate degradation", "Minor degradation", "Minimal degradation", "Full functionality retained"],
  "reusability.cross": ["None", "Minimal compatibility", "Limited compatibility", "Moderate compatibility", "High compatibility", "Designed for cross-product/system reuse"],
  // 8. Refurbishability
  "refurbishability.clean": ["Not possible", "Very difficult", "Difficult", "Moderate effort", "Easy", "Very easy, minimal intervention needed"],
  "refurbishability.inspect": ["Not possible", "Very difficult", "Difficult, needs specialized equipment", "Moderate effort, standard test equipment", "Easy, accessible test points", "Built-in diagnostics / very easy testing"],
  "refurbishability.worn": ["Not possible", "Very difficult", "Difficult", "Moderate effort", "Easy", "Tool-free replacement during refurbishment"],
  "refurbishability.restore": ["Cannot restore performance", "Minimal restoration achievable", "Partial restoration achievable", "Moderate restoration achievable", "Near-original performance restored", "Full original performance restored"],
  "refurbishability.procs": ["None available", "Informal/undocumented", "Limited internal documentation only", "Basic procedures available", "Detailed procedures, publicly available", "Comprehensive public procedures plus guides"],
  // 9. Remanufacturability
  "remanufacturability.cores": ["None recoverable", "Minimal recovery", "Limited recovery", "Moderate recovery", "High recovery", "Nearly all core components recoverable"],
  "remanufacturability.std": ["No standardization", "Proprietary, unique per unit", "Partially standardized", "Standardized within product line", "Standardized across product family", "Industry-standard rebuild interfaces"],
  "remanufacturability.reassembly": ["Not possible", "Very difficult", "Difficult", "Moderate effort", "Easy", "Very easy reassembly"],
  "remanufacturability.highvalue": ["None reusable", "Minimal reuse", "Limited reuse", "Moderate reuse", "High reuse", "Nearly all high-value assemblies reusable"],
  "remanufacturability.verify": ["No verification possible", "Very difficult to verify", "Limited standard tests available", "Moderate testing available", "Comprehensive testing available", "Fully standardized QA protocol"],
  // 10. Recyclability
  "recyclability.separation": ["Inseparable", "Under 20% separable", "20–40% separable", "40–60% separable", "60–80% separable", "Over 80% separable"],
  "recyclability.pct": ["Under 10% by mass", "10–30% by mass", "30–50% by mass", "50–70% by mass", "70–90% by mass", "Over 90% by mass"],
  "recyclability.identify": ["No material marking", "Minimal / inconsistent marking", "Partial marking", "Marked on major components", "Marked per recognized standard (e.g., ISO 11469)", "Fully marked and documented to international standard"],
  "recyclability.composites": ["Mostly composite / inseparable", "Significant composite content", "Moderate composite content", "Limited composite content", "Minimal composite content", "No inseparable composite materials"],
  "recyclability.hazardous": ["Contains restricted/hazardous substances", "Significant hazardous content", "Some hazardous content", "Minimal, within regulatory limits", "Fully compliant (e.g., RoHS/REACH)", "Zero hazardous substances, fully documented"],
};

/* ---------- Shared Design Assessment store (used by Design tab + Report) ---------- */

function seedDesignState() {
  const scores = {};
  const notes = {};
  for (const c of designFramework) {
    scores[c.key] = {};
    notes[c.key] = "";
    for (const s of c.subCriteria) scores[c.key][s.key] = s.score;
  }
  return { scores, notes };
}

let _designState = seedDesignState();
const _listeners = new Set();

export const designStore = {
  get: () => _designState,
  subscribe: (fn) => { _listeners.add(fn); return () => _listeners.delete(fn); },
  setScore(criterion, sub, value) {
    _designState = {
      ..._designState,
      scores: { ..._designState.scores, [criterion]: { ..._designState.scores[criterion], [sub]: value } },
    };
    _listeners.forEach((f) => f());
  },
  setNote(criterion, note) {
    _designState = { ..._designState, notes: { ..._designState.notes, [criterion]: note } };
    _listeners.forEach((f) => f());
  },
};

export function computeDciFromState(s) {
  let total = 0;
  const perCriterion = {};
  for (const c of designFramework) {
    const sum = c.subCriteria.reduce((a, sc) => a + (s.scores[c.key]?.[sc.key] ?? 0), 0);
    perCriterion[c.key] = sum;
    total += sum;
  }
  const dci = (total / 250) * 100;
  return { perCriterion, total, dci, grade: dciGrade(dci) };
}

/* ---------- Shared Scope & Boundary store (used by Scope, Utility, Report tabs) ---------- */

export const domainRoles = {
  Manufacturing: ["Production Manager", "Manufacturing Engineer", "Process Engineer", "Product Designer", "Industrial Designer", "Eco-design Specialist", "Circular Economy Designer", "R&D Engineer", "Plant Manager", "Quality Engineer", "Sustainability Manager", "Product Stewardship Manager", "Environmental Manager"],
  "Supply Chain & Logistics": ["Supply Chain Manager", "Procurement Manager", "Purchasing Manager", "Vendor Manager", "Supplier Representative", "Logistics Manager", "Warehouse Manager", "Inventory Manager", "Distribution Manager", "Export Manager", "Import Manager"],
  "Design & Engineering": ["Architect", "Landscape Architect", "Interior Designer", "Civil Engineer", "Structural Engineer", "Mechanical Engineer", "Electrical Engineer", "Environmental Engineer", "Manufacturing Engineer", "Process Engineer", "Design Engineer", "BIM Engineer", "Design Consultant"],
  "Construction & Infrastructure": ["Project Manager", "Construction Manager", "Site Engineer", "Builder", "Main Contractor", "General Contractor", "EPC Engineer", "Quantity Surveyor", "Project Engineer", "Asset Manager", "Facility Manager", "Building Manager"],
  "Operations & Maintenance": ["Operations Manager", "Maintenance Manager", "Maintenance Engineer", "Reliability Engineer", "Asset Manager", "Facility Manager", "Utility Manager", "Plant Manager", "Service Engineer"],
  "Circular Economy & End-of-Life": ["Circular Economy Manager", "Recycling Manager", "Resource Recovery Manager", "Waste Manager", "Recycling Engineer", "Remanufacturing Engineer", "Refurbishment Manager", "Repair Engineer", "Reverse Logistics Manager", "Take-back Program Manager", "Material Recovery Specialist"],
  "Sustainability & Assessment": ["Sustainability Manager", "ESG Manager", "Environmental Manager", "Circular Economy Consultant", "Environmental Consultant", "Sustainability Consultant", "LCA Practitioner", "LCA Consultant", "Carbon Consultant", "Net Zero Consultant", "Product Stewardship Manager"],
  "Compliance & Verification": ["Compliance Officer", "Regulatory Affairs Manager", "Auditor", "Third-party Verifier", "Certification Auditor", "EPD Specialist", "Quality Assurance Manager", "Quality Control Engineer", "Environmental Compliance Officer", "Government Inspector"],
  "Digital Product Management": ["Product Manager", "Product Data Manager", "Product Lifecycle (PLM) Manager", "BIM Manager", "Digital Product Passport (DPP) Manager", "Material Passport Manager", "Information Manager", "Digital Twin Manager"],
  "Research & Academia": ["Professor", "Research Scientist", "Research Engineer", "University Researcher", "Academic Researcher", "Postdoctoral Researcher", "Doctoral Researcher (PhD)", "Student", "Laboratory Technician"],
};

let _scopeState = {
  domain: "Manufacturing",
  domainCustom: "",
  role: "Production Manager",
  roleCustom: "",
  showEnergy: false,
  showWater: false,
  showEconomic: false,
};
const _scopeListeners = new Set();

export const scopeStore = {
  get: () => _scopeState,
  subscribe: (fn) => { _scopeListeners.add(fn); return () => _scopeListeners.delete(fn); },
  set: (patch) => {
    _scopeState = { ..._scopeState, ...patch };
    _scopeListeners.forEach((f) => f());
  },
};

export function resolvedUserTypeLabel(s) {
  const role = s.role === "Other" ? (s.roleCustom.trim() || "Other") : s.role;
  const domain = s.domain === "Other" ? (s.domainCustom.trim() || "Other domain") : s.domain;
  return role ? `${role} (${domain})` : domain;
}
